module.exports = __webpack_public_path__ + "img/bag1.080bbd58.png";